import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=38962bde"
import script from "./parameters.vue?vue&type=script&lang=js"
export * from "./parameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38962bde')) {
      api.createRecord('38962bde', component.options)
    } else {
      api.reload('38962bde', component.options)
    }
    module.hot.accept("./parameters.vue?vue&type=template&id=38962bde", function () {
      api.rerender('38962bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reports/outbound-texts/parameters.vue"
export default component.exports